/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _leftPad = _interopRequireDefault(require("../utils/leftPad"));
var _default = function _default(_ref) {
  var value = _ref.value,
    _ref$separator = _ref.separator,
    separator = _ref$separator === void 0 ? ':' : _ref$separator,
    meridiem = _ref.meridiem;
  var parts = value.split(separator);
  var hours = parts[0];
  var minutes = parts[1];
  var seconds = parts[2];
  var result = {
    hours: hours,
    minutes: minutes
  };
  if (typeof seconds == 'string' && seconds.length) {
    result.seconds = seconds;
  }
  if (meridiem && seconds !== undefined && seconds * 1 != seconds) {
    result.seconds = (0, _leftPad.default)(parseInt(seconds, 10));
  }
  if (meridiem && seconds === undefined && minutes * 1 != minutes) {
    result.minutes = (0, _leftPad.default)(parseInt(minutes, 10));
  }
  if (meridiem) {
    var meridiems = ['am', 'AM', 'pm', 'PM'];
    var indexes = meridiems.map(function (m) {
      return (seconds || minutes).indexOf(m);
    });
    indexes.forEach(function (indexOf, i) {
      if (indexOf != -1) {
        result.meridiem = meridiems[i];
      }
    });
  }
  return result;
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/Calendar/src/TimeInput/toTimeValue.js
// module id = 235
// module chunks = 0